import { CARD_SIZE_OPTIONS } from "./branding-defaults";

export const BRANDING_HOME_CARDS = [
  {
    uploadField: "nextMatchCard",
    imageKey: "imageNextMatchCard",
    enabledKey: "enabledNextMatchCard",
    textKey: "textNextMatchCard",
    priorityKey: "priorityNextMatchCard",
    sizeKey: "sizeNextMatchCard",
    defaultTextId: "gestion.branding.cards.nextMatch",
    previewHeight: 120,
    hideSize: true,
    featured: true,
    editable: true,
  },
  {
    uploadField: "barCard",
    imageKey: "imageBarCard",
    enabledKey: "enabledBarCard",
    textKey: "textBarCard",
    priorityKey: "priorityBarCard",
    sizeKey: "sizeBarCard",
    defaultTextId: "gestion.branding.cards.bar",
    previewHeight: 72,
    editable: true,
    availableSizes: CARD_SIZE_OPTIONS.standard,
  },
  {
    uploadField: "cardsCard",
    imageKey: "imageCardsCard",
    enabledKey: "enabledCardsCard",
    textKey: "textCardsCard",
    priorityKey: "priorityCardsCard",
    sizeKey: "sizeCardsCard",
    defaultTextId: "gestion.branding.cards.cards",
    previewHeight: 72,
    editable: true,
    availableSizes: CARD_SIZE_OPTIONS.standard,
  },
  {
    uploadField: "fairplayCard",
    imageKey: "imageFairplayCard",
    enabledKey: "enabledFairplayCard",
    textKey: "textFairplayCard",
    priorityKey: "priorityFairplayCard",
    sizeKey: "sizeFairplayCard",
    defaultTextId: "gestion.branding.cards.fairplay",
    previewHeight: 72,
    editable: true,
    availableSizes: CARD_SIZE_OPTIONS.standard,
  },
  {
    uploadField: "fixtureCard",
    imageKey: "imageFixtureCard",
    enabledKey: "enabledFixtureCard",
    textKey: "textFixtureCard",
    priorityKey: "priorityFixtureCard",
    sizeKey: "sizeFixtureCard",
    defaultTextId: "gestion.branding.cards.fixture",
    previewHeight: 72,
    editable: true,
    availableSizes: CARD_SIZE_OPTIONS.standard,
  },
  {
    uploadField: "goalersCard",
    imageKey: "imageGoalersCard",
    enabledKey: "enabledGoalersCard",
    textKey: "textGoalersCard",
    priorityKey: "priorityGoalersCard",
    sizeKey: "sizeGoalersCard",
    defaultTextId: "gestion.branding.cards.goalers",
    previewHeight: 72,
    editable: true,
    availableSizes: CARD_SIZE_OPTIONS.standard,
  },
  {
    uploadField: "outstandingCard",
    imageKey: "imageOutstandingCard",
    enabledKey: "enabledOutstandingCard",
    textKey: "textOutstandingCard",
    priorityKey: "priorityOutstandingCard",
    sizeKey: "sizeOutstandingCard",
    defaultTextId: "gestion.branding.cards.outstanding",
    previewHeight: 72,
    editable: true,
    availableSizes: CARD_SIZE_OPTIONS.standard,
  },
  {
    uploadField: "positionsCard",
    imageKey: "imagePositionsCard",
    enabledKey: "enabledPositionsCard",
    textKey: "textPositionsCard",
    priorityKey: "priorityPositionsCard",
    sizeKey: "sizePositionsCard",
    defaultTextId: "gestion.branding.cards.positions",
    previewHeight: 72,
    editable: true,
    availableSizes: CARD_SIZE_OPTIONS.standard,
  },
  {
    uploadField: "suspendedCard",
    imageKey: "imageSuspendedCard",
    enabledKey: "enabledSuspendedCard",
    textKey: "textSuspendedCard",
    priorityKey: "prioritySuspendedCard",
    sizeKey: "sizeSuspendedCard",
    defaultTextId: "gestion.branding.cards.suspended",
    previewHeight: 72,
    editable: true,
    availableSizes: CARD_SIZE_OPTIONS.standard,
  },
  {
    uploadField: "teamCard",
    imageKey: "imageTeamCard",
    enabledKey: "enabledTeamCard",
    textKey: "textTeamCard",
    priorityKey: "priorityTeamCard",
    sizeKey: "sizeTeamCard",
    defaultTextId: "gestion.branding.cards.team",
    previewHeight: 72,
    editable: true,
    availableSizes: CARD_SIZE_OPTIONS.standard,
  },
  {
    uploadField: "ad1",
    imageKey: "ad1Image",
    enabledKey: "ad1Enabled",
    linkKey: "ad1Link",
    priorityKey: "ad1Priority",
    sizeKey: "ad1Size",
    defaultTextId: "gestion.branding.cards.ad1",
    previewHeight: 72,
    editable: true,
    isAd: true,
    availableSizes: CARD_SIZE_OPTIONS.ads,
  },
  {
    uploadField: "ad2",
    imageKey: "ad2Image",
    enabledKey: "ad2Enabled",
    linkKey: "ad2Link",
    priorityKey: "ad2Priority",
    sizeKey: "ad2Size",
    defaultTextId: "gestion.branding.cards.ad2",
    previewHeight: 72,
    editable: true,
    isAd: true,
    availableSizes: CARD_SIZE_OPTIONS.ads,
  },
  {
    uploadField: "ad3",
    imageKey: "ad3Image",
    enabledKey: "ad3Enabled",
    linkKey: "ad3Link",
    priorityKey: "ad3Priority",
    sizeKey: "ad3Size",
    defaultTextId: "gestion.branding.cards.ad3",
    previewHeight: 72,
    editable: true,
    isAd: true,
    availableSizes: CARD_SIZE_OPTIONS.ads,
  },
  {
    uploadField: "loginBackground",
    imageKey: "imageLoginBackground",
    enabledKey: "loginLogoEnabled",
    defaultTextId: "gestion.branding.cards.login",
    previewHeight: 160,
    editable: false,
    loginOnly: true,
  },
];

export const PREVIEW_HOME_CARDS = BRANDING_HOME_CARDS.filter((card) => !card.loginOnly);
